import { logger } from '@gem/modules/logger';

import { Features } from 'APP/packages/features/Features';
import Entities from 'STORE';

export function handleMessageKeywords(property) {
  try {
    if (Features.isMarketplaceEnabled()) {
      const { settings = [] } = JSON.parse(property.value);
      settings.forEach((item) => {
        Entities.clientConfig.addMessageKeywords(item.keyWordType, item.animationUrl);
      });
    }
  } catch (error) {
    logger.get('Tasks').error('login.clientConfig.messageKeyword', error);
  }
}
